import { FileAction } from '@nextcloud/files';
import { showError, showSuccess } from '@nextcloud/dialogs';
import { translate as t } from '@nextcloud/l10n';
import { DateTimePreset, getDateString, getDateTime, getVerboseDateString } from '../shared/utils';
import { logger } from '../shared/logger';
import { SET_REMINDER_MENU_ID } from './setReminderMenuAction';
import { setReminder } from '../services/reminderService';
import './setReminderSuggestionActions.scss';
const laterToday = {
    dateTimePreset: DateTimePreset.LaterToday,
    label: t('files_reminders', 'Later today'),
    ariaLabel: t('files_reminders', 'Set reminder for later today'),
};
const tomorrow = {
    dateTimePreset: DateTimePreset.Tomorrow,
    label: t('files_reminders', 'Tomorrow'),
    ariaLabel: t('files_reminders', 'Set reminder for tomorrow'),
};
const thisWeekend = {
    dateTimePreset: DateTimePreset.ThisWeekend,
    label: t('files_reminders', 'This weekend'),
    ariaLabel: t('files_reminders', 'Set reminder for this weekend'),
};
const nextWeek = {
    dateTimePreset: DateTimePreset.NextWeek,
    label: t('files_reminders', 'Next week'),
    ariaLabel: t('files_reminders', 'Set reminder for next week'),
};
/**
 * Generate a file action for the given option
 *
 * @param option The option to generate the action for
 * @return The file action or null if the option should not be shown
 */
const generateFileAction = (option) => {
    const dateTime = getDateTime(option.dateTimePreset);
    if (!dateTime) {
        return null;
    }
    return new FileAction({
        id: `set-reminder-${option.dateTimePreset}`,
        displayName: () => `${option.label} – ${getDateString(dateTime)}`,
        title: () => `${option.ariaLabel} – ${getVerboseDateString(dateTime)}`,
        // Empty svg to hide the icon
        iconSvgInline: () => '<svg></svg>',
        enabled: () => true,
        parent: SET_REMINDER_MENU_ID,
        async exec(node) {
            // Can't really happen, but just in case™
            if (!node.fileid) {
                logger.error('Failed to set reminder, missing file id');
                showError(t('files_reminders', 'Failed to set reminder'));
                return null;
            }
            // Set the reminder
            try {
                await setReminder(node.fileid, dateTime);
                showSuccess(t('files_reminders', 'Reminder set for "{fileName}"', { fileName: node.basename }));
            }
            catch (error) {
                logger.error('Failed to set reminder', { error });
                showError(t('files_reminders', 'Failed to set reminder'));
            }
            // Silent success as we display our own notification
            return null;
        },
        order: 21,
    });
};
// Generate the default preset actions
export const actions = [laterToday, tomorrow, thisWeekend, nextWeek]
    .map(generateFileAction)
    .filter(Boolean);
